<template>
  <div id="BalanceSheetPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-12">
        <h1 class="title">
          BALANCE SHEET
        </h1>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline has-text-left ">
        <div class="column is-8-desktop is-12-tablet  is-12-mobile">
          <img src="@/assets/documents/balance_sheet_manual_1.png" alt="" />
          <img src="@/assets/documents/balance_sheet_manual_2.png" alt="" />
          <img src="@/assets/documents/balance_sheet_manual_3.png" alt="" />
          <img src="@/assets/documents/balance_sheet_manual_4.png" alt="" />
        </div>
        <div class="column is-4-desktop is-12-tablet  is-12-mobile">
          <h1 class="subtitle is-5">
            🏢
            จงอย่าลงทุนในบริษัทที่ไม่เข้าใจในแม้ในเรื่องการเงินของตนเอง...ชีวิตคนเราก็เช่นกัน!
          </h1>
          <p>
            การทำงบดุล และ งบกระแสเงินสดส่วนบุคคลก็สำคัญไม่แพ้กัน!
            <br /><br />
            📊ยุคนี้จึงมีระบบการทำงบดุลงบกระแสที่อำนวยความสะดวกได้กว่าเดิม
            ดูง่ายสะอาดตา พร้อมอัตราส่วนทางการเงิน
            <br /><br />
            📑งบดุล (Balance Sheet)<br />
            เป็นงบแรกที่ต้องทำขึ้นมาเพื่อ<br />
            - ตรวจสอบสถานะความมั่นคง<br />
            - เป็นการจำแนกทรัพย์สินสภาพคล่องให้เห็นชัดขึ้น<br />
            - ได้เห็นผลลัพธ์จากการลงทุนว่าเติบโตขึ้นกี่%<br />
            - ทำให้ทราบถึงความมั่นคงสุทธิ
            <br /><br />
            📑งบกระแสเงินสด(Cash flow)<br />
            - รวบรวมข้อมูลแหล่งเงินได้<br />
            - ทำให้เห็นถึงสัดส่วนรายจ่ายที่สำคัญ และที่ฟุ่มเฟือยเกินไป<br />
            - เป็นข้อมูลคาดการณ์ทั้งปี
            <br /><br />
            ถ้าอยากรู้ว่า ความสงบทางใจเป็นเช่นไร? ต้องลองสร้างดู!
            <br /><br />
          </p>

          <div class="columns">
            <div class="column">
              <p class="title is-6">ดาวโหลดแบบฟอร์ม</p>
              <div class="columns is-mobile is-centered">
                <div class="column">
                  <a @click.prevent="downloadFileAxios('excel')">
                    <figure class="image is-96x96">
                      <img src="@/assets/web_icons/excel_icon.png" />
                    </figure>
                  </a>
                  <p>ไฟล์ Excel</p>
                </div>
                <div class="column">
                  <a @click.prevent="downloadFileAxios('numbers')">
                    <figure class="image is-96x96">
                      <img src="@/assets/web_icons/numbers_icon.png" />
                    </figure>
                  </a>
                  <p>ไฟล์ Numbers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BalanceSheetPage",
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    downloadFileAxios: function(type) {
      let file_extend = "";

      switch (type) {
        case "excel":
          file_extend = ".xlsx";
          break;
        default:
          file_extend = ".numbers";
          break;
      }
      axios({
        url: this.publicPath + "docs/balance_sheet" + file_extend,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "BalanceSheet_Cashflow" + file_extend
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
};
</script>

<style></style>
